import { IPin, IPinProduct, PinType } from 'src/@interfaces'
import { FeatureFlagValue } from 'src/hooks'
import { PinProduct } from '../PinProduct'
import { Image } from '@grupoboticario/flora-react'
import { getPinSizeAsNumber } from 'src/helpers'
import { PinLink } from '../PinLink'

interface MagazinePinProps {
  pin: IPin
  loadingPinId?: string
  pinBagIcon: string
  catalogPinsSize?: FeatureFlagValue
  onAdd?: (items: IPinProduct) => void
}

export const MagazinePin = ({
  pin,
  loadingPinId,
  pinBagIcon,
  catalogPinsSize,
  onAdd,
}: MagazinePinProps) => {
  const isLoading = loadingPinId === pin.id

  switch (pin.pinType) {
    case PinType.PIN:
      return (
        <PinProduct
          key={pin.id}
          pin={pin}
          loading={isLoading}
          icon={
            <Image
              src={pinBagIcon}
              alt=""
              size="62.5%"
              css={{ pointerEvents: 'none', touchAction: 'none' }}
            />
          }
          onClick={() => onAdd?.(pin)}
          pinSize={getPinSizeAsNumber(pin, catalogPinsSize)}
        />
      )

    case PinType.INTERNAL:
    case PinType.EXTERNAL:
      return (
        <PinLink
          key={pin.id}
          pin={pin}
        />
      )

    default:
      return null
  }
}
